export default {
  // Profile
  orgId: '오그 아이디',
  memberName: '회원명',
  corporateName: '법인/회사명',
  loginId: '아이디',
  administratorName: '대표 관리자 이름',
  administratorPhoneNumber: '대표 관리자 번호',
  memberRegistrationDate: '회원가입 일시',
  serviceType: '서비스 구분',
  currentPassword: '현재 비밀번호',
  newPassword: '새 비밀번호',
  passwordFormatErrorContent: '유효하지 않은 비밀번호 형식입니다.',
  passwordMatchErrorContent: '입력한 새 비밀번호가 일치하지 않습니다',
  currentPasswordMatchErrorContent: '현재 사용중인 비밀번호가 일치하지 않습니다',
  updatePasswordSuccessContent: '비밀번호 업데이트가 완료되었습니다.',
  profileCaption: '* 회원 정보 수정을 원하시는 경우 영업 담당자 또는 1:1문의로 요청바랍니다.',
  passwordChange: '비밀번호 변경',
  att: '알림톡',
  ftt: '친구톡',
  unsubscribe: '수신거부 설정',
  adUnsubscribe: '광고성 문자 수신거부',
  informationUnsubscribe: '정보성 문자 수신거부',
  passwordCaption: '비밀번호는 영문,숫자,특수문자 중 2종류 이상을 조합하여 최소 8자이상 설정해주세요.',
  changeBtn: '변경',
  confirmNewPassword: '비밀번호 확인',
  memberLastLoginDate: '최종 로그인',
};
